import { Injectable } from '@angular/core';
import { EncuestaDaService } from './encuesta-da.service';
import { RespuestaFormulario } from 'src/app/shared/components/formularios-encuesta/models/respuesta-formulario';
import { CabeceraRespuesta } from 'src/app/shared/components/formularios-encuesta/models/cabecera-respuesta';

@Injectable({
  providedIn: 'root'
})
export class EncuestaBlService {

  constructor(
    private encuestaDaService: EncuestaDaService
  ) { }

  getFormularioExterno(rutaParcial:string){
    return this.encuestaDaService.getCartaExterno(rutaParcial);
  }

  insertRespuestaEncuesta(idFormulario:string, listaRespuestas:CabeceraRespuesta){
    return this.encuestaDaService.insertEncuesta(idFormulario, listaRespuestas);

  }
  getFormularioExternoRespuesta(codigoFormulario: string, fechaInicial:Date, fechaFinal:Date){
    return this.encuestaDaService.getFormularioExternoRespuesta(codigoFormulario, fechaInicial, fechaFinal);
  }
}
